import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import contentHelper from '../../lib/contentHelper';
import { RELATED_ARTICLES } from '../constants/PropTypesShapes';
import {
  ECM_DOC_ID_KEY,
  ECM_COMPONENT_IDS_KEY,
  ECM_DOC_ID_DEFAULT_VALUE,
  ECM_COMPONENT_IDS_DEFAULT_VALUE,
} from '../constants/ecmFPTITagsKeys';

const cobrand = Page.getCountry();

class RelatedArticles extends Component {
  constructor(props) {
    super(props);

    this.renderArticleListItem = this.renderArticleListItem.bind(this);
  }

  fptiTracking(articleContent) {
    const faqId = articleContent.articleId;
    // get the ECM API tags from article data
    const fptiDocId = (articleContent && articleContent[ECM_DOC_ID_KEY]) || ECM_DOC_ID_DEFAULT_VALUE;
    const fptiComponentIds =
      (articleContent && articleContent[ECM_COMPONENT_IDS_KEY]) || ECM_COMPONENT_IDS_DEFAULT_VALUE;

    const upfrontFAQId = this.props.upfront;
    trackLink({
      id: `${this.props.FPTIPageName}`,
      link: `${this.props.link}${upfrontFAQId}|${faqId}`,
      help_doc_id: fptiDocId,
      help_component_ids: fptiComponentIds,
    });
  }

  renderArticleListItem(articleInfo) {
    let href;
    let articleTitle = articleInfo.articleTitle;

    if (!this.props.community) {
      href = `${this.props.relatedRedirectURL}${Page.getFormattedUrlForArticle(
        articleInfo.articleTitle,
        articleInfo.articleId,
      )}`;
    } else {
      href = articleInfo.link;
      const communitySearchTitle = i18n.message('smarthelp/searchResult.searchResult.link.communityTitle', {
        title: articleInfo.articleTitle,
        views: articleInfo.views,
      });
      articleTitle = contentHelper(communitySearchTitle, { title: articleInfo.articleTitle, views: articleInfo.views });
    }
    return (
      <li key={articleInfo.articleId}>
        <p>
          <Link
            href={href}
            target={this.props.target}
            rel="noopener noreferrer"
            onClick={() => this.fptiTracking(articleInfo)}
          >
            {articleTitle}
          </Link>
        </p>
      </li>
    );
  }

  renderArticleList() {
    const { relatedArticles } = this.props; // eslint-disable-line react/prop-types
    const displayNumber = this.props.displayNumber;
    const displayList = relatedArticles && relatedArticles.slice(0, displayNumber);
    const articleList = displayList.map(this.renderArticleListItem);
    if (articleList.length) {
      return <ul className="related-article-list">{articleList}</ul>;
    }
    return null;
  }

  render() {
    return (
      <div className="related-articles-component">
        <p className="title" id="test-related-article-header">
          {this.props.header}
        </p>
        <div className="contents">{this.renderArticleList()}</div>
      </div>
    );
  }
}

RelatedArticles.defaultProps = {
  relatedArticles: [],
  displayNumber: 2,
  header: '',
  upfront: '',
  FPTIPageName: 'contactUsPage',
  target: '_blank',
  relatedRedirectURL: `/${cobrand}/smarthelp/article/`,
  community: false,
  link: 'smarthelp-related-article',
};

RelatedArticles.propTypes = {
  displayNumber: PropTypes.number,
  header: PropTypes.string,
  upfront: PropTypes.string,
  FPTIPageName: PropTypes.string,
  target: PropTypes.string,
  relatedRedirectURL: PropTypes.string,
  community: PropTypes.bool,
  link: PropTypes.string,
  relatedArticles: PropTypes.arrayOf(PropTypes.shape(RELATED_ARTICLES)),
};

export default RelatedArticles;
